import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Lightweight public client — does NOT attach auth headers or redirect on 401.
export const publicApi = axios.create({ baseURL: API_BASE });

export function publicError(err) {
    const detail = err?.response?.data?.detail;
    if (!detail) return err?.message || "Something went wrong";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
    return String(detail);
}
